import {useUtmParams} from '@/hooks/useUtmParams'
import {Outlet} from 'react-router-dom'

export const PublicLayout = () => {
    useUtmParams()
    return <Outlet />
}
